import { Directive } from '@angular/core';

@Directive({
  selector: 'panel-tools'
})
export class PanelToolsDirective { }
